import Box from '@mui/material/Box';

export default function FormIntroText({ children }) {
	return <Box sx={{ mb: 3 }}>{children}</Box>;
}
